import React from 'react';
import { useEmbedFilters } from './EmbedWrapper';
import { useResourcePlanningData } from '../../hooks/useEmbedData';
import { ResourcePlanningGauges } from '../GaugeChart';

const EmbedResourcePlanning: React.FC = () => {
  const filters = useEmbedFilters();
  const { data, isLoading, error } = useResourcePlanningData(filters);

  if (error) {
    return <div className="text-red-600 text-center py-4">Error: {error}</div>;
  }

  return <ResourcePlanningGauges data={data} isLoading={isLoading} />;
};

export default EmbedResourcePlanning;
